import { render, staticRenderFns } from "./AddReviewAction.vue?vue&type=template&id=45aacc7f&"
import script from "./AddReviewAction.vue?vue&type=script&lang=js&"
export * from "./AddReviewAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports